<ng-template #tableTemplate>
    <n-data-table id="remove-ip-white-list-table"
        style="height: 3rem;"
        [columnDefs]="tableColumnDefs"
        [data]="dataList">
    </n-data-table>
</ng-template>
